import { Form, Input, Row, Col, Button, Divider, Typography } from "antd";
import { MailOutlined } from "@ant-design/icons"
import { Link, useNavigate } from "react-router-dom";
import "../../styles/forgot-password.css";
import "../../styles/login.css";
import Logo from "../../assets/logo.png"

const { Text } = Typography;

export default function EnterMail(){
  const navigate = useNavigate();
  const navigateToNext = () => navigate("confirm")
  
  return(
    <>
      <div className="container">
        <Row style={{ height: "100vh", margin: 0 }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="col-left">
            <div className="img-container">
              <img className="school-logo" src={Logo} alt="Nasarawa State University Logo" />
            </div>
            <div className="headline">
              <h1>
                Nasarawa State University, Keffi
              </h1>
              <Text style={{ 
                color: 'rgba(255,255,255,0.9)', 
                fontSize: '1.2em',
                fontWeight: 300,
                marginTop: '0.5em',
                display: 'block'
              }}>
                E-Bursary Management System
              </Text>
            </div>
            <div className="forgot-password">
              <Link to="/login" className="link">Back to Login</Link>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} className="col-right">
            <div className="login-box">
              <div className="header">
                <h1>Reset Password</h1>
                <Text style={{ 
                  color: 'rgba(44, 62, 80, 0.7)', 
                  fontSize: '1.1em',
                  display: 'block',
                  marginBottom: '0.5em'
                }}>
                  Enter your email address to receive a reset code
                </Text>
                <Divider />
              </div>
              <Form 
                wrapperCol={{
                  span: 24,
                }}
                size="large"
                layout="vertical">
                <Form.Item 
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your email address',
                    },
                    {
                      type: 'email',
                      message: 'Please enter a valid email address',
                    },
                  ]}
                  name="email">
                  <Input 
                    size="large" 
                    placeholder="Enter your email address"
                    prefix={<MailOutlined className="icon"/>}
                    type="email"
                  />
                </Form.Item>
                <Form.Item
                  wrapperCol={{
                    span: 24,
                  }}
                  className="submit-button-wrapper"
                >
                  <Button 
                    onClick={() => navigateToNext()} 
                    size="large" 
                    className="submit-button" 
                    htmlType="submit" 
                    block 
                    style={{
                      display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center'
                    }}
                  >
                    Send Reset Code
                  </Button>
                </Form.Item>
                <div style={{ 
                  textAlign: 'center', 
                  marginTop: '1.5em',
                  paddingTop: '1.5em',
                  borderTop: '1px solid rgba(0,0,0,0.1)'
                }}>
                  <Text style={{ 
                    color: 'rgba(44, 62, 80, 0.6)', 
                    fontSize: '0.95em' 
                  }}>
                    Remember your password?
                  </Text>
                  <br />
                  <Link 
                    to="/login" 
                    style={{ 
                      color: '#14C38E',
                      fontWeight: 500,
                      textDecoration: 'none',
                      fontSize: '0.95em',
                      marginTop: '0.5em',
                      display: 'inline-block'
                    }}
                  >
                    Back to Login
                  </Link>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}
